import { Box } from "@mui/material";
import { ReactNode } from "react";

import HeaderV2 from "@/layout/MainLayout/HeaderV2";
import useStyles from "./index.styles";

interface DeadAccountFullscreenLayoutProps {
  children: ReactNode;
  /** Center content vertically (dead gate screen). */
  centered?: boolean;
}

const DeadAccountFullscreenLayout = ({
  children,
  centered = false,
}: DeadAccountFullscreenLayoutProps) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <HeaderV2 minimal />

      <Box className={classes.content}>
        <Box
          className={
            centered ? classes.contentInnerGate : classes.contentInner
          }
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default DeadAccountFullscreenLayout;
